<template>
  <div
    class="flex flex-nowrap items-center mt-24 border-b border-neutral-100/10"
  >
    <q-tabs
      v-model="tab"
      active-color="primary-pure"
      @update:model-value="updateTab"
    >
      <q-tab
        v-if="assessment.nome_exibicao"
        name="current"
      >
        <p class="!text-headline-3">
          {{ assessment.nome_exibicao }}
        </p>
      </q-tab>
      <q-tab name="previous" class="!text-headline-3">
        <p class="!text-headline-3">
          {{ t('previousReviews') }}
        </p>
      </q-tab>
    </q-tabs>
    <div class="flex-1" />

    <ToggleView
      v-if="tipoOpcao.tradicional"
      class="px-24"
      @click:view="$emit('click:view', $event)"
    />
  </div>
  <q-tab-panels v-if="assessment.show_periods" v-model="tab" animated>
    <q-tab-panel name="previous">
      <div class="flex mx-24 mt-24 overflow-hidden">
        <OSelectPaginated
          ref="selectPaginatedRef"
          :model-value="model.period"
          :api-url="`api/assessment/${assessment.id}/periods`"
          :adictional-filters="{
            fields: `id,nome_exibicao`,
          }"
          option-label="nome_exibicao"
          option-value="id"
          class="max-w-[350px] w-full bg-white"
          @update:model-value="onChangePeriods"
        />
      </div>
    </q-tab-panel>
  </q-tab-panels>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { watchOnce } from '@vueuse/core'
import OSelectPaginated from 'components/Select/OSelectPaginated.vue'
import ToggleView from 'components/PagePergunta/ToggleView.vue'
import useAssessment from 'composables/useAssessment'

const props = defineProps({
  tipoOpcao: Object,
})

const { t } = useI18n()
const { assessment } = useAssessment()

const route = useRoute()
const router = useRouter()

const tab = computed(() => route.query.tab || 'current')
const selectPaginatedRef = ref(null)

const model = ref({
  period: {
    id: null,
    nome_exibicao: '',
  },
})

async function updateTab(newTab) {
  const current = newTab === 'current'
  const period = current ? { period: undefined } : {} // tira da url quando clicar em current
  router.push({ query: { ...route.query, tab: newTab, ...period } })

  if (current) emit('click:current')
  else emit('click:periods')
}

function onChangePeriods(opt) {
  router.push({
    query: { ...route.query, period: opt.id },
  })
  model.value.period = opt
  emit('click:periods', opt)
}

onMounted(() => {
  watchOnce(
    () => selectPaginatedRef.value?.options,
    (options) => {
      const period = route.query.period
      if (options.length > 0) {
        const opt = period
          ? options.find(({ id }) => id === +period)
          : options[0]

        model.value.period = opt
      }
    }
  )
})

const emit = defineEmits([
  'click:periods',
  'click:current',
  'click:view',
])
</script>

<style lang="scss" scoped></style>
